module.exports = __webpack_public_path__ + "static/img/6.fe28f96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/6.png
// module id = 4Q2M
// module chunks = 0